import OverlaySpinner from './OverlaySpinner'
import OverlayText from './OverlayText'
import { OVERLAY_TEXT, OVERLAY_SPINNER } from '../../../constants/overlayTypes'

const GeneralRequestOverlay = ({title, text, overlayType, onResetOverlay, showResult=false}) => {
    if(OVERLAY_SPINNER === overlayType) {
        return <OverlaySpinner 
            transId={title}
        />
    } else if(OVERLAY_TEXT === overlayType) {
        if(showResult) {
            return <OverlayText
                titleTransId={title}
                text={text}
                buttonTextTransId='button_close'
                onClickButton={onResetOverlay}
            />
        } else {
            return ''
        }
    } else {
        return ''
    }
}

export default GeneralRequestOverlay